import { showConfirmationPopupAction } from 'js/components/common/popups/ConfirmationPopup';

import { acceptBonusMessage } from './server';

export const showBonusPopupAction = ({ id, layer, title, content, dialogId, acceptBtnText, declineBtnText, onClose }) => {
    const onAccept = () => acceptBonusMessage({ accept: true, dialogId });
    const onDecline = () => acceptBonusMessage({ accept: false, dialogId });

    return showConfirmationPopupAction({
        id,
        layer,
        title,
        className: 'bonus-popup',
        content,
        onClose,
        onAccept,
        onDecline,
        acceptBtnText,
        declineBtnText
    });
};
